import PopUp from "../../atoms/popUp/PopUp";
import styles from "./Modal.module.css";

function Modal({ grey, yellow, onClose, innerRef, children, ...props }) {
  return (
    <div className={styles.background} onClick={onClose}>
      <PopUp className={styles.modal} children={children} grey={grey} yellow={yellow} innerRef={innerRef} {...props} />
    </div>
  );
}

export default Modal;
